export const environment = {
	production: false,
	apiBase: 'http://41.208.68.19:3001'
};


